/**
 * **arcade テーマ**（Issue #523）。格ゲー風の HUD ＋ 光る区画のマット。
 *
 * テーマが持つのは**見た目だけ**（層をどう描くか・HUD の場所と絵）。
 * 層が何であるかは `core/theme` の `FIELD_LAYERS`、紙と投影は `stage/` の器。
 */
import { toHud } from '../../core/hud';
import { toTheme } from '../../core/theme';
import { EFFECTS } from './effects';
import field, { FIELD_PARTS, FIELD_SCHEMA, FIELD_STYLE } from './drawField';
import objects, { MARK_PARTS, MARK_SCHEMA, MARK_STYLE, OBJECT_PARTS, OBJECT_SCHEMA, OBJECT_STYLE } from './drawObjects';
import ArcadeHud, { HUD_PARTS, HUD_SCHEMA, HUD_STYLE, anchors } from './drawHud';

export default toTheme({
  name: 'arcade',
  label: '格ゲー風',
  field,
  objects,
  effects: EFFECTS,
  /*
   * **触れるものの宣言と既定値**（Issue #523）。HUD の数値はここが唯一の真実で、
   * `drawHud.js` に magic number を残さない ——「AI が初稿を書き、人が GUI で詰める」ための形。
   * 見た目の選択（手札を出す・アイコンの絵・内側の辺）も**テーマとして保持したい値**なので
   * `hud.options` ではなく `style` に置く。`hud.options` に残るのはページが切り替えるものだけ。
   */
  schema: { ...HUD_SCHEMA, ...FIELD_SCHEMA, ...OBJECT_SCHEMA, ...MARK_SCHEMA },
  style: { ...HUD_STYLE, ...FIELD_STYLE, ...OBJECT_STYLE, ...MARK_STYLE },
  /**
   * **このテーマだけが持つ部品**（枠の中の要素）と、**飾りを名乗る部品**（Issue #523）。
   * `core/theme` が共通のトランスフォームと、名乗った組の飾りを自動で付けるので、
   * 宣言はここだけ（既定値は各ファイルの `*_STYLE`）。
   */
  parts: [...HUD_PARTS, ...FIELD_PARTS, ...OBJECT_PARTS, ...MARK_PARTS],
  hud: toHud({ anchors, Component: ArcadeHud, options: {} }),
  options: {
    /** ゾーンの枠にキーの文字を出す（`lines` の層） */
    zoneLabels: true,
  },
});
